import { withDependencies } from '@wix/thunderbolt-ioc'
import { IPageDidMountHandler, CurrentRouteInfoSymbol, pageIdSym } from '@wix/thunderbolt-symbols'
import { ICurrentRouteInfo } from 'feature-router'
import { IReporterApi } from '../types'
import { ReporterSymbol } from '../symbols'
import { reportPageView } from './report-page-view'
import { IPageNumber, PageNumberSymbol } from 'feature-business-logger'

const reporterNavigationHandlerFactory = (
	reporterApi: IReporterApi,
	currentRouteInfo: ICurrentRouteInfo,
	pageNumber: IPageNumber,
	pageId: string
): IPageDidMountHandler => ({
	pageDidMount: () => reportPageView(reporterApi, currentRouteInfo, pageNumber, pageId),
})

export const ReporterNavigationHandler = withDependencies(
	[ReporterSymbol, CurrentRouteInfoSymbol, PageNumberSymbol, pageIdSym],
	reporterNavigationHandlerFactory
)
